const getBackendBaseURL = () => {
    const origin = window.location.origin;
  
    if (origin.includes("localhost")) {
      return "http://localhost:5000/api-ayurmax"; // Local Development
    } else if (origin.includes("staging2")) {
      return "https://staging2.aseetsoft.com/api-ayurmax"; // Staging Environment
    } else if (origin.includes("staging")) {
      return "https://staging.aseetsoft.com/api-ayurmax"; // Staging Environment
    } else {
      return "https://aseetsoft.com/api-ayurmax"; // Production Environment
    }
  };
  
  const CONFIG = {
    BASE_URL: getBackendBaseURL(),
//    HTTP_PROTOCOL: window.location.protocol,
//    DOMAIN_NAME: window.location.hostname,
  };
  
  export default CONFIG;
  